import React from "react"
import { BodyTextRegular } from "../../typography/text"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { css, useTheme } from "@emotion/react"
import { returnCheckboxAndRadioStyle } from "./field-style-util"

const textStyle = css`
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.35);
`
const iconStyle = css`
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.5));
`
type Props = {
  innerRef?: any
  innerText?: string
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
export const StyledCheckbox = ({ innerText, innerRef, ...rest }: Props) => {
  const theme = useTheme()
  return (
    <div css={returnCheckboxAndRadioStyle(theme, "4px")}>
      <input type="checkbox" ref={innerRef} {...rest} />
      <span className="customElement">
        <div className="checkedIndicator">
          <BodyTextRegular css={textStyle}>
            {innerText ? (
              innerText
            ) : (
              <FontAwesomeIcon css={iconStyle} icon={solid("check")} />
            )}
          </BodyTextRegular>
        </div>
      </span>
    </div>
  )
}
